import { lazy } from 'react';

export const MedDeviceManufacturerDetailsPage = lazy(
  () => import('./MedDeviceManufacturerDetailsPage'),
);
